import Image, { ImageProps } from 'next/image';

const ProductPanel = ({ srcImage = '', ...props }: { srcImage: string } & ImageProps) => {
  return <Image id="image-article-dtl" src={srcImage} {...props} />;
};

export default ProductPanel;
